import { defineComponent as _defineComponent } from 'vue'
import 'leaflet/dist/leaflet.css';

	import AppFooter from '@/components/layout/app-footer.vue';
	import AppHeader from '@/components/layout/app-header/app-header.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'app',
  setup(__props) {

	
return { __sfc: true,AppFooter, AppHeader }
}

})